import { Directive, Input, OnInit, HostListener, OnDestroy, HostBinding } from '@angular/core';
import { MatSidenav } from '@angular/material';
import { MediaObserver } from '@angular/flex-layout';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { GLinkMatchMediaService } from 'app/core/services/match-media.service';
import { GLinkMatSidenavHelperService } from 'app/core/directives/glink-mat-sidenav/glink-mat-sidenav.service';

@Directive({
    selector: '[glinkMatSidenavHelper]'
})
export class GLinkMatSidenavHelperDirective implements OnInit, OnDestroy
{
    @HostBinding('class.mat-is-locked-open')
    isLockedOpen: boolean;

    // tslint:disable-next-line:no-input-rename
    @Input('glinkMatSidenavHelper')
    id: string;

    // tslint:disable-next-line:no-input-rename
    @Input('mat-is-locked-open')
    matIsLockedOpenBreakpoint: string;

    // Private
    private _unsubscribeAll: Subject<any>;

    /**
     * Constructor
     *
     * @param {GLinkMatchMediaService} _glinkMatchMediaService
     * @param {GLinkMatSidenavHelperService} _glinkMatSidenavHelperService
     * @param {MatSidenav} _matSidenav
     * @param {MediaObserver} _observableMedia
     */
    constructor(
        private _glinkMatchMediaService: GLinkMatchMediaService,
        private _glinkMatSidenavHelperService: GLinkMatSidenavHelperService,
        private _matSidenav: MatSidenav,
        private _observableMedia: MediaObserver
    )
    {
        // Set the defaults
        this.isLockedOpen = true;

        // Set the private defaults
        this._unsubscribeAll = new Subject();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void
    {
        // Register the sidenav to the service
        this._glinkMatSidenavHelperService.setSidenav(this.id, this._matSidenav);

        if ( this._observableMedia.isActive(this.matIsLockedOpenBreakpoint) )
        {
            this.isLockedOpen = true;
            this._matSidenav.mode = 'side';
            this._matSidenav.toggle(true);
        }
        else
        {
            this.isLockedOpen = false;
            this._matSidenav.mode = 'over';
            this._matSidenav.toggle(false);
        }

        this._glinkMatchMediaService.onMediaChange
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(() => {
                if ( this._observableMedia.isActive(this.matIsLockedOpenBreakpoint) )
                {
                    this.isLockedOpen = true;
                    this._matSidenav.mode = 'side';
                    this._matSidenav.toggle(true);
                }
                else
                {
                    this.isLockedOpen = false;
                    this._matSidenav.mode = 'over';
                    this._matSidenav.toggle(false);
                }
            });
    }

    /**
     * On destroy
     */
    ngOnDestroy(): void
    {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }
}

@Directive({
    selector: '[glinkMatSidenavToggler]'
})
export class GLinkMatSidenavTogglerDirective
{
    // tslint:disable-next-line:no-input-rename
    @Input('glinkMatSidenavToggler')
    id;

    /**
     * Constructor
     *
     * @param {GLinkMatSidenavHelperService} _glinkMatSidenavHelperService
     */
    constructor(
        private _glinkMatSidenavHelperService: GLinkMatSidenavHelperService)
    {
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * On click
     */
    @HostListener('click')
    // tslint:disable-next-line:typedef
    onClick()
    {
        this._glinkMatSidenavHelperService.getSidenav(this.id).toggle();
    }
}
